{
  "name": "@openrail/netzgrafik-editor-frontend",
  "version": "2.12.2",
  "repository": {
    "type": "git",
    "url": "https://github.com/OpenRailAssociation/netzgrafik-editor-frontend.git"
  },
  "files": [
    "dist/*"
  ],
  "type": "module",
  "types": "dist/types/types.d.ts",
  "exports": {
    "./index.html": {
      "default": "./dist/index.html"
    },
    ".": {
      "types": "./dist/types/src/types.d.ts",
      "default": "./dist/out-tsc/src/types.js"
    }
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration=local",
    "start:standalone": "ng serve --configuration=standalone",
    "start:standalonedemo": "ng serve --configuration=standalonedemo",
    "build": "ng run netzgrafik-frontend:ngsscbuild",
    "build:standalone": "ng build --configuration=standalone && tsc --project tsconfig.defs.json",
    "build:standalonedemo": "ng build --configuration=standalonedemo",
    "test": "ng test -c ci",
    "format": "oxfmt",
    "format:check": "oxfmt --check",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:null": "tsc --project tsconfig.strictNullChecks.json",
    "generate:api": "openapi-generator-cli generate",
    "local-test": "ng test --watch --code-coverage",
    "extract-i18n": "ng extract-i18n",
    "benchmark": "ng test -c benchmark"
  },
  "dependencies": {
    "@angular/animations": "22.2.1",
    "@angular/cdk": "22.2.1",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/elements": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/localize": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/router": "22.2.1",
    "@sbb-esta/angular": "^22.1.0",
    "angular-oauth2-oidc": "^22.0.2",
    "angular-server-side-configuration": "^22.0.2",
    "d3": "^7.9.0",
    "dompurify": "^3.4.16",
    "extract-i18n": "^1.0.0",
    "ngx-editor": "^18.0.0",
    "papaparse": "^5.7.0",
    "rxjs": "^7.8.2",
    "save-svg-as-png": "^1.4.17",
    "tslib": "^2.5.3",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@angular/build": "22.2.1",
    "@angular/cli": "22.2.1",
    "@angular/compiler-cli": "22.2.1",
    "@angular/language-service": "22.2.1",
    "@commitlint/types": "^21.2.3",
    "@eslint/js": "^10.0.1",
    "@openapitools/openapi-generator-cli": "^2.41.0",
    "@types/d3": "^7.4.3",
    "@types/karma-jasmine": "^4.0.5",
    "@types/node": "^26.6.4",
    "@types/papaparse": "^5.3.2",
    "angular-eslint": "^22.5.0",
    "browserstack-local": "^1.5.15",
    "eslint": "^10.11.0",
    "eslint-config-prettier": "^10.1.8",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "6.3.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.4",
    "karma-browserstack-launcher": "^1.6.0",
    "karma-chrome-launcher": "^3.1.1",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.3.0",
    "karma-sonarqube-reporter": "^1.4.0",
    "oxfmt": "^0.70.0",
    "ts-node": "~10.9.2",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.71.1"
  }
}
